import { useToastContext } from '../../context/ToastContextProvider';

export const useToast = () => {
    const context = useToastContext();
    return context;
};